import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import AuthCard from "./pages/authPages/card.js";
import ResetPassword from "./pages/authPages/ResetPassword.js";
import SendPasswordResetEmail from "./pages/authPages/SendPasswordResetEmail.js";
import PrivacyPolicy from "./pages/policyPages/privacy_policy.js";
import TermsAndConditions from "./pages/policyPages/terms&conditions.js";

import AuthLayout from "./layout/authLayout.js";
import VerifyEmail from "./pages/authPages/verifyEmail.js";
import { useSelector } from "react-redux";
import ChangePassword from "./pages/authPages/ChangePassword.js";

//Post pages 
import PostHome from "./pages/post/home.js";
import PostHistory from "./pages/post/history.js";
import PostSatisfied from "./pages/post/satisfied.js";
import PostSaves from "./pages/post/saves.js";
import PostFilter from "./pages/post/filter.js";
import PostDetailView from "./components/post/post-detail-view.jsx"; 
import DonorCommunityPage from './pages/join-donor-community.jsx';
import PostLayout from './layout/postLayout.js';

//profile Pages: 
import ProfileLayout from './layout/profileLayout.js';
import ProfileDetail from "./pages/profile/profile.js";
import AllProfiles from './pages/profile/allProfiles.js';
import AllOrgs from "./pages/profile/allOrgs.js";
import NearMe from "./pages/profile/near-me.js";
import MasjidMadrasa from "./pages/profile/masjid-madrasa.js";
import Following from "./pages/profile/following.js";
import Followers from "./pages/profile/followers.js";
import MasarifEZakat from "./pages/mainPages/MasarifeZakat.jsx";
import AboutAddaZakat from './pages/mainPages/AboutAddaZakat.jsx';
import ZakatCalculator from './pages/mainPages/calculateZakat.jsx';

import { useState, useEffect } from 'react';
import { Loading } from "./components/Loading.js";

import "./globals.css";
import NotFound from './pages/404.jsx';
import GoogleCallback from './pages/authPages/GoogleCallback.js';

function App() {
  const { access_token } = useSelector(state => state.auth)
  const [authChecked, setAuthChecked] = useState(false);
  
  useEffect(() => {
    setAuthChecked(true);
  }, []);

  if (!authChecked) {
    return <Loading />;
  }
  
  return (  
    <>
      <HelmetProvider>
        <BrowserRouter>
          <Routes>

            <Route path="/policy" element={<PrivacyPolicy />} />
            <Route path="/terms_and_condition" element={<TermsAndConditions />} />

            <Route path="/auth" element={<AuthLayout />}>
              <Route path="login/" element={!access_token ? <AuthCard /> : <Navigate to="/" />} />
              <Route path="sendpasswordresetemail/" element={<SendPasswordResetEmail />} />
              <Route path="user/reset/:id/:token/" element={<ResetPassword />} />
              <Route path="verify-email" element={<VerifyEmail />} />
              <Route path="change_password/" element={<ChangePassword />} />
              <Route path="google-login/" element={<GoogleCallback />} />
            </Route>       

            <Route path="/" element={<PostLayout />} >
              <Route index element={<AboutAddaZakat/>} />
              <Route path="satisfied/" element={<PostSatisfied />} />
              <Route path="history/" element={<PostHistory />} />
              <Route path="saves/"  element={<PostSaves />} />
              <Route path="filter" element={<PostFilter />} />
              <Route path="detail/:slug" element={<PostDetailView />}/>
              <Route path="donor-community" element={<DonorCommunityPage />} />
              <Route path="who-to-pay-zakat" element={<MasarifEZakat />} />
              <Route path="calculate-zakat" element={<ZakatCalculator />} />
              <Route path="posts" element={<PostHome />} />
            </Route>

            <Route path="/profiles" element={<ProfileLayout /> }>
              <Route path=":username" element={<ProfileDetail />} />
              <Route index element={<AllProfiles />} />
              <Route path="organization" element={<AllOrgs />} />
              <Route path="masjid-madrasa" element={<MasjidMadrasa />} />
              <Route path=":username/near-me" element={<NearMe />} />
              <Route path=":username/followers" element={<Followers />} />
              <Route path=":username/following" element={<Following />} />
            </Route>

            <Route path="*" element={<NotFound />} />

          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </>
  );
}

export default App;
